import { randFloat, randProductCategory } from '@ngneat/falso';

import { CartageCharge } from '../cartage-charge';

export class MockCartageCharge extends CartageCharge {
   constructor() {
      super({
         type: randProductCategory(),
         amount: randFloat(),
         currency: 'USD',
      });
   }
}
